import { SalesIncentiveType } from "@utils/enums";

import { ProductTileApiModel } from "./product/api/productTile.api.model";

export type Media = {
    altText?: string | null;
    code?: string;
    description?: string | null;
    format?: string | null;
    mimeType?: string | null;
    url: string;
};

export type MainImage = {
    code: string;
    medias: Array<Media>;
};

export type Video = {
    code: string;
    name: string;
    url: string;
};

export type TLocalizedAttributes<T> = {
    nl_BE: T;
    fr_BE: T;
    fr_FR?: T;
};

export type References = {
    accessories?: any[];
    consistsOfs?: any[];
    crosssells?: any[];
    diffOrderUnits?: any[];
    followups?: any[];
    mandatories?: any[];
    montages?: any[];
    others?: any[];
    selects?: any[];
    similars?: any[];
    spareparts?: any[];
    upsells?: any[];
};

export type EnhancedReferences = Omit<
    References,
    "montages" | "accessories"
> & {
    montages?: Array<AdditionalServiceModel>;
    accessories?: Array<ProductTileApiModel>;
};

export type AdditionalServiceModel = {
    sku: string;
    title: string;
    price?: number;
    id?: string;
    documents?: Array<ProductDocument>;
};

export type ProductDocument = {
    altText: string | null;
    code: string;
    description: string | null;
    format: string;
    mimeType: string;
    url: string;
};

export enum PromoLabelType {
    Promo = "promo",
    EveryDayLowPrice = "everyDayLowPrice",
    FreeTransport = "freeTransport",
    Cashback = "cashback",
    FreeArticle = "freeArticle",
}

export type PromoLabel = {
    salesIncentiveType: SalesIncentiveType;
    formattedPromotionValue?: string;
    promoLabeLType: PromoLabelType;
};
